import { TaskStatusKeys } from 'domain/task-status-enum';

export class Task {
  /**
   * Returns true if the given task is currently or has already fulfilled the given status.
   * @param task
   * @param status
   */
  static isStatusFulFilled(task, status = '') {
    if (TaskStatusKeys[status.toUpperCase()] === undefined) {
      return false;
    }
    // Dont take into account DECLINED and UNKNOWN status
    const filteredKeys = Object.keys(TaskStatusKeys);

    const taskIndex = filteredKeys.indexOf(task.status.toUpperCase());
    const givenIndex = filteredKeys.indexOf(status.toUpperCase());
    if (taskIndex !== -1 && givenIndex !== -1) {
      return taskIndex >= givenIndex;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/domain/task.js